import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { ProductDefault } from '../subcomponents/product-default/ProductDefault';
import { ProductPodDefaultProps, ProductPodPropTypes } from '../Helper';
import { productPodDefaultDataModel } from '../dataModel';
import { ProductPodDefaultMobile } from './ProductPodDefaultMobile';
import { ProductPodDefaultDesktop } from './ProductPodDefaultDesktop';

export const ProductPodDefault = (props) => {
  const { channel } = useContext(ExperienceContext);

  if (channel === 'mobile') {
    /* eslint-disable react/jsx-props-no-spreading */
    return <ProductPodDefaultMobile {...props} />;
  }
  /* eslint-disable react/jsx-props-no-spreading */
  return <ProductPodDefaultDesktop {...props} />;
};

ProductPodDefault.propTypes = ProductPodPropTypes;

ProductPodDefault.defaultProps = ProductPodDefaultProps;

ProductDefault.displayName = 'ProductDefault';

ProductPodDefault.dataModel = productPodDefaultDataModel;
